import { _ as _objectSpread2 } from './objectSpread2-6043052c.js';

function omit(obj, fields) {
  var clone = _objectSpread2({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function (key) {
      delete clone[key];
    });
  }
  return clone;
}

export { omit as o };
